import {Component, Input, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {UntypedFormBuilder, UntypedFormGroup} from '@angular/forms';
import {Customer} from '../model/customer';
import {FieldServiceService} from '../services/field-service.service';
import {UserService} from '../../user/user.service';
import {Subscription} from 'rxjs';
import {AlertService} from '../../../common/alert-service/alert.service';
import {CustomerIndustrialSectorService} from '../services/customer-industrial-sector.service';
import {IndustrialSector, IndustrialSectorForm} from '../../industrial-sector/producer.models';
import {MultiSelectConfig} from '../../../common/multi-select-config';
import {debounceTime} from 'rxjs/operators';
import {IMultiSelectOption, IMultiSelectSettings, IMultiSelectTexts} from '../../../common/multiselect/types';

@Component({
    selector: 'customer-detail-industrial-sector',
    templateUrl: './customer-detail-industrial-sector.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CustomerDetailIndustrialSectorComponent implements OnInit {
  @Input() customer: Customer;
  @Input() industrialSectors: IndustrialSector[];
  myForm: UntypedFormGroup;
  formSubscription?: Subscription;
  error = false;
  errors: { [key: string]: any; } = {};
  model: number[];
  options: IMultiSelectOption[] = [];

  settings: IMultiSelectSettings = MultiSelectConfig.settings;
  texts: IMultiSelectTexts = MultiSelectConfig.texts;

  constructor(private fb: UntypedFormBuilder,
              private alertService: AlertService,
              private userService: UserService,
              private fieldServiceService: FieldServiceService,
              private customerService: CustomerIndustrialSectorService) {
  }

  ngOnInit(): void {
    this.myForm = this.fb.group({
      optionsModel: [this.customer.industrial_sectors],
    });
    this.myForm.controls['optionsModel'].valueChanges
      .pipe(debounceTime(550))
      .subscribe((selectedOptions) => {
        this.updateCustomer(selectedOptions);
      });
    this.industrialSectors.map(p => this.options.push({id: p.name, name: p.name}));
  }

  private updateCustomer(values: string[]): void {
    const form = {names: values} as IndustrialSectorForm;
    this.customerService.updateProducers(this.customer.id, form).subscribe(() => {
      this.alertService.add('success', 'Kundendaten erfolgreich gespeichert!');
    }, response => {
      if (response.error) {
        this.errors = response.error;
      }
      this.alertService.add('danger', 'Es ist ein Fehler aufgetreten, bitte überprüfen Sie Ihre Eingabe!');
    });
  }

}
